export var APPEND_INIIALIZE = "@@firekit/LISTS@APPEND_INIIALIZE";
export var INIIALIZE = "@@firekit/LISTS@INIIALIZE";
export var DESTROY = "@@firekit/LISTS@DESTROY";
export var UNWATCH = "@@firekit/LISTS@UNWATCH";
export var CHILD_ADDED = "@@firekit/LISTS@CHILD_ADDED";
export var CHILD_CHANGED = "@@firekit/LISTS@CHILD_CHANGED";
export var CHILD_REMOVED = "@@firekit/LISTS@CHILD_REMOVED";